var map = {
	"./API/Index.vue": 3093,
	"./API/Partials/ApiTokenManager.vue": 8752,
	"./Admin/Dashboard/DashboardAdmin.vue": 4462,
	"./Admin/Dashboard/DashboardLojista.vue": 4508,
	"./Admin/Dashboard/DashboardPrefeitura.vue": 2270,
	"./Admin/Noticias/Categorias/Index.vue": 4383,
	"./Admin/Noticias/Index.vue": 1434,
	"./Admin/Notificacao/Admin.vue": 6048,
	"./Admin/Notificacao/Detalhes.vue": 5088,
	"./Admin/Notificacao/Index.vue": 2665,
	"./Admin/Notificacao/Msg.vue": 8519,
	"./Admin/Permissions/Index.vue": 5658,
	"./Admin/Prefeituras/Index.vue": 6771,
	"./Admin/Prefeituras/Usuarios/Index.vue": 1614,
	"./Admin/Profile/Index.vue": 4100,
	"./Admin/Roles/Index.vue": 8459,
	"./Admin/Servicos/Categorias/Index.vue": 474,
	"./Admin/Servicos/Cupons/Index.vue": 9559,
	"./Admin/Servicos/Index.vue": 4874,
	"./Admin/Servicos/Lojistas/Index.vue": 3847,
	"./Admin/Servicos/Revisao/Index.vue": 4888,
	"./Admin/Servicos/Subcategorias/Index.vue": 8394,
	"./Admin/Servicos/Tags/Index.vue": 4174,
	"./Admin/Settings/Index.vue": 8462,
	"./Admin/Usuarios/Index.vue": 3638,
	"./Auth/ConfirmPassword.vue": 4861,
	"./Auth/ForgotPassword.vue": 561,
	"./Auth/Login.vue": 9148,
	"./Auth/Register.vue": 1656,
	"./Auth/ResetPassword.vue": 2033,
	"./Auth/TwoFactorChallenge.vue": 7056,
	"./Auth/VerifyEmail.vue": 5186,
	"./Bloqueado.vue": 3276,
	"./Dashboard.vue": 8900,
	"./Lojista/Cupom/Index.vue": 6156,
	"./Lojista/Dashboard/DashboardLojista.vue": 5308,
	"./Lojista/Notificacao/Index.vue": 5248,
	"./Lojista/Register/Confirmacao.vue": 6028,
	"./Lojista/Register/Index.vue": 3101,
	"./Lojista/Servico/Confirmacao.vue": 2584,
	"./Lojista/Servico/Index.vue": 9422,
	"./Lojista/Usuarios/Index.vue": 2068,
	"./Lojista/Welcome/Index.vue": 1723,
	"./PrivacyPolicy.vue": 7108,
	"./Profile/Partials/DeleteUserForm.vue": 5691,
	"./Profile/Partials/LogoutOtherBrowserSessionsForm.vue": 8205,
	"./Profile/Partials/TwoFactorAuthenticationForm.vue": 9563,
	"./Profile/Partials/UpdatePasswordForm.vue": 2060,
	"./Profile/Partials/UpdateProfileInformationForm.vue": 9978,
	"./Profile/Show.vue": 3185,
	"./TermsOfService.vue": 7461,
	"./Welcome.vue": 9570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1230;